/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AdminSearchInfo} from '../models/AdminSearchInfo';
import type {Error} from '../models/Error';

export interface SearchAdminUsers$Request {
    profileId: number;
    excludeExisting: boolean;
    email?: string;
}

export interface SearchAdminUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchAdminUsersRequest = createAction<PayloadData<void, SearchAdminUsers$Request>>('SEARCH_ADMIN_USERS__SEARCH_ADMIN_USERS__REQUEST');
export const searchAdminUsersSuccess = createAction<PayloadData<Array<AdminSearchInfo>, SearchAdminUsers$Request>>('SEARCH_ADMIN_USERS__SEARCH_ADMIN_USERS__SUCCESS');
export const searchAdminUsersFailure = createAction<PayloadData<Error, SearchAdminUsers$Request, true>>('SEARCH_ADMIN_USERS__SEARCH_ADMIN_USERS__FAILURE');

export const searchAdminUsersActions = [
    searchAdminUsersRequest,
    searchAdminUsersSuccess,
    searchAdminUsersFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {boolean} meta.excludeExisting
 * @param {string} [meta.email]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchAdminUsers = (meta: SearchAdminUsers$Request, config?: SearchAdminUsers$Config) => {
    const TRANSPORT_GET_PARAMS = {
        email: meta.email,
        profileId: meta.profileId,
        excludeExisting: meta.excludeExisting,
    };
    return {
        CALL_API: {
            types: searchAdminUsersActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admin-users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

